import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-67063d23")

_pushScopeId("data-v-67063d23")
const _hoisted_1 = {
  id: "pickup-detail-v2-page",
  "data-testid": "pickup-detail-page",
  style: {"display":"contents"}
}
const _hoisted_2 = { class: "h-full rounded-2xl bg-white p-3 shadow-md border-card-pickup mx-3" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { "data-testid": "pickup-detail-section-info" }
const _hoisted_6 = {
  key: 0,
  class: "mt-4 p-3 bg-gray-100 rounded"
}
const _hoisted_7 = {
  "data-testid": "pickup-detail-cancel-reason-label",
  class: "text-xs font-semibold text-gray-500 block mb-1"
}
const _hoisted_8 = { class: "max-w-full overflow-hidden" }
const _hoisted_9 = { class: "text-sm text-gray-800 break-all" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PickUpDetailHeader = _resolveComponent("PickUpDetailHeader")!
  const _component_PickupDetailSummaryRow = _resolveComponent("PickupDetailSummaryRow")!
  const _component_PickupDetailRequestInfo = _resolveComponent("PickupDetailRequestInfo")!
  const _component_PickupDetailSttTable = _resolveComponent("PickupDetailSttTable")!
  const _component_PickupDetailSidebar = _resolveComponent("PickupDetailSidebar")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_PickupCancelConfirmModal = _resolveComponent("PickupCancelConfirmModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DetailLayout, {
        scrollSidebar: "",
        customClass: "px-0 h-fit",
        headerNewLayout: "",
        onBack: _ctx.goBack,
        verticalSeparator: false,
        loading: _ctx.isLoading,
        error: _ctx.isError,
        errorType: _ctx.errorCause,
        onTryAgain: _ctx.fetchDetail
      }, {
        title: _withId(() => [
          _createVNode(_component_PickUpDetailHeader, {
            pickupId: _ctx.pickupId,
            specialHandling: _ctx.detailData.specialHandling
          }, null, 8, ["pickupId", "specialHandling"])
        ]),
        data: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_PickupDetailSummaryRow, {
                  totalRequest: _ctx.summaryTotalRequestProps,
                  totalPickup: _ctx.summaryTotalPickupProps,
                  agentHub: _ctx.summaryAgentHubProps,
                  loading: _ctx.isLoading
                }, null, 8, ["totalRequest", "totalPickup", "agentHub", "loading"])
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_PickupDetailRequestInfo, {
                  isPcaEmpty: _ctx.isPcaEmpty,
                  corporateAddress: _ctx.requestInfoCorporateAddress,
                  fallbackAddress: _ctx.detailData.pickupAddress,
                  fallbackGeoloc: _ctx.detailData.geoloc,
                  courierNote: _ctx.detailData.courierNote,
                  loading: _ctx.isLoading
                }, null, 8, ["isPcaEmpty", "corporateAddress", "fallbackAddress", "fallbackGeoloc", "courierNote", "loading"])
              ]),
              _createVNode("div", null, [
                _createVNode(_component_PickupDetailSttTable, {
                  listStt: _ctx.detailData.listStt,
                  loading: _ctx.isLoading
                }, null, 8, ["listStt", "loading"])
              ])
            ])
          ])
        ]),
        "sub-data": _withId(() => [
          _createVNode(_component_PickupDetailSidebar, _mergeProps(_ctx.sidebarProps, {
            phoneRevealed: _ctx.phoneRevealed,
            mergedShipments: _ctx.mergedShipments,
            loading: _ctx.isLoading,
            onRevealPhone: _ctx.onRevealPhone,
            onOpenCancelModal: _ctx.openCancelModal,
            canShowCancelButton: _ctx.canShowCancelButton,
            canPrintDhlLabel: _ctx.detailData.canPrintDhlLabel,
            dhlLabelPrintUrl: _ctx.detailData.dhlLabelPrintUrl,
            onPrintLabel: _ctx.onPrintLabel
          }), null, 16, ["phoneRevealed", "mergedShipments", "loading", "onRevealPhone", "onOpenCancelModal", "canShowCancelButton", "canPrintDhlLabel", "dhlLabelPrintUrl", "onPrintLabel"]),
          (_ctx.detailData?.isCancelled && _ctx.detailData?.cancelNote)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("pickup.cancel.sidebar.reasonLabel")), 1),
                _createVNode("div", _hoisted_8, [
                  _createVNode("p", _hoisted_9, _toDisplayString(_ctx.detailData.cancelNote), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain"])
    ]),
    _createVNode(_component_PickupCancelConfirmModal, {
      "is-open": _ctx.isConfirmModalOpen,
      "is-loading": _ctx.isSubmitting,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isConfirmModalOpen = false)),
      onConfirm: _ctx.handleCancelSubmit
    }, null, 8, ["is-open", "is-loading", "onConfirm"])
  ], 64))
})